import SearchVisibility from "@/pages/SearchVisibility";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {createFileRoute} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/search-visibility")({
  component: RouteComponent,
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
    }),
  },
  validateSearch: zodValidator(
    z.object({
      addCountry: z.boolean().optional(),
      tab: z.enum(["competitors", "keywords", "opportunities", "overview"]).catch("overview"),
    }),
  ),
  loader: ({params}) => {
    getDefaultStore().set(selectedCompanyIdAtom, params.companyId);
  },
});

function RouteComponent() {
  const {companyId} = Route.useParams();
  const {tab} = Route.useSearch();
  return <SearchVisibility companyProfileId={companyId} tab={tab} />;
}
